import React from 'react'
import Page from '../Page'
import { PortalType, SlotPortal } from '../Portal'
import Breadcrumbs from '../Breadcrumbs'
import { useNavigation } from '../../utils/navigation'
import { Col } from '../List/Col'
import { Stat } from '../StatsPanel'
import Button, { ButtonActive } from '../Button/Button'
import styles from '../../../CSS/main.css'
import classNames from 'classnames'

type Props = {
  readonly title: string
  readonly stats?: ReadonlyArray<ReadonlyArray<Stat>>
  readonly statsTitle?: string
  readonly onSave: () => void
  readonly onCancel: () => void
}

const EditPage: React.FC<Props> = ({
  title,
  children,
  statsTitle,
  stats,
  onCancel,
  onSave,
}) => {
  const { goBack } = useNavigation()
  return (
    <Page isInfoPage>
      <div className={classNames([styles.Table, styles.Layout2Col])}>
        <SlotPortal name={PortalType.Toolbar}>
          <Breadcrumbs
            onBack={goBack}
            title={title}
            actionButtons={[
              <Button key='cancel' onClick={onCancel}>
                Cancel
              </Button>,
              <ButtonActive key='save' onClick={onSave}>
                Save changes
              </ButtonActive>,
            ]}
          />
        </SlotPortal>
        <Col>{children}</Col>
        {/*<Col>{stats && <StatsPanel title={statsTitle} stats={stats} />}</Col>*/}
      </div>
    </Page>
  )
}

export default EditPage
